import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URLS from "../../urls";
//axios
import axios from "../../utils/axios";
//----------------------------------------------------

// GET =>  getParentsForSchool
export const getParentsForSchool = createAsyncThunk(
  "parents/getParentsForSchool",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.getParentsForSchoolURL, {
        params: {
          school_id: params?.school_id,
          page: params?.page,
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// POST =>  createParentForSchool
export const createParentForSchool = createAsyncThunk(
  "parents/createParentForSchool",
  async (params, thunkAPI) => {
    try {
      const response = await axios.post(
        URLS.createParentForSchoolURL,
        params?.data,
        {
          params: {
            school_id: params?.school_id,
          },
        }
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// Delete =>  deleteParentData
export const deleteParentData = createAsyncThunk(
  "parents/deleteParentData",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.deleteParentDataURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// Get =>  getParentData
export const getParentData = createAsyncThunk(
  "parents/getParentData",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.getParentDataURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// PUT =>  editParentData
export const editParentData = createAsyncThunk(
  "parents/editParentData",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.editParentDataURL}/${params?.id}`,
        params?.data
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
// POST =>  SEND NOTIFI TO SERVICE
export const sendNotificationToParentsService = createAsyncThunk(
  "parents/sendNotificationToParentsService",
  async (params, thunkAPI) => {
    try {
      
      const response = await axios.post(
        URLS.sendNotificationToParentsURL,
        params?.data
      );
      console.log(response)
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  CHECK NOTIFI TO SERVICE
export const checkNewNotificationsService = createAsyncThunk(
  "parents/checkNewNotificationsService",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(URLS.checkNewNotificationsURL);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
